import { render, staticRenderFns } from "./NotEnoughData.vue?vue&type=template&id=05a23935&"
import script from "./NotEnoughData.vue?vue&type=script&lang=js&"
export * from "./NotEnoughData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports